import { FC, useCallback, useEffect, useState } from "react";
import CalendarImg from "./Img/calendar_sprite.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import "./DataPiker.scss";
import ImageSprite from "../ImageSprite/ImageSprite";
import moment from "moment";

type DatePickerProps = {
    startDateHandler: (startDate: number | undefined) => void;
    endDateHandler: (endDate: number | undefined) => void;
    startDate?: number | undefined;
    endDate?: number | undefined;
    leftLabel: string;
};

const DataPiker: FC<DatePickerProps> = ({
    endDateHandler,
    startDateHandler,
    leftLabel,
    startDate,
    endDate,
}) => {
    useEffect(() => {
        if (startDate !== undefined) {
            const date = moment.unix(startDate).toDate();
            setRangeStart(date);
        } else {
            setRangeStart(undefined);
        }
    }, [startDate]);

    useEffect(() => {
        if (endDate !== undefined) {
            const date = moment.unix(endDate).toDate();
            setRangeEnd(date);
        } else {
            setRangeEnd(undefined);
        }
    }, [endDate]);

    const [rangeStart, setRangeStart] = useState<Date | undefined>(undefined);
    const [rangeEnd, setRangeEnd] = useState<Date | undefined>(undefined);

    const selectStartDate = useCallback(
        (date: Date) => {
            setRangeStart(date);
            const unixTimestamp = date ? moment(date).unix() : undefined;
            startDateHandler(unixTimestamp);
        },
        [startDateHandler]
    );

    const selectEndDate = useCallback(
        (date: Date) => {
            setRangeEnd(date);
            const unixTimestamp = date ? moment(date).unix() : undefined;
            endDateHandler(unixTimestamp);
        },
        [endDateHandler]
    );

    return (
        <div className="data_piker">
            <div className="data_piker__left_label">{leftLabel}</div>
            <div className="form_control">
                <DatePicker
                    className="form_control__input"
                    selectsStart
                    selected={rangeStart}
                    endDate={rangeEnd}
                    onChange={(date) => selectStartDate(date as Date)}
                    showTimeSelect
                    timeInputLabel="Time:"
                    dateFormat="MM/dd/yyyy hh:mm aa"
                    popperClassName="popup_data_piker"
                    placeholderText="Date From"
                    clearButtonClassName="popup_data_piker__action_button"
                    isClearable
                />
                <span className="animation-bg"></span>
            </div>

            <div className="form_control">
                <DatePicker
                    className="form_control__input"
                    selectsEnd
                    selected={rangeEnd}
                    startDate={rangeStart}
                    endDate={rangeEnd}
                    onChange={(data) => selectEndDate(data as Date)}
                    showTimeSelect
                    timeInputLabel="Time:"
                    dateFormat="MM/dd/yyyy hh:mm aa"
                    popperClassName="popup_data_piker"
                    placeholderText="To"
                    clearButtonClassName="popup_data_piker__action_button"
                    isClearable
                />
                <span className="animation-bg"></span>
            </div>
            <div className="data_piker__icon">
                <ImageSprite iconSprite={`${CalendarImg}#calendar`} />
            </div>
        </div>
    );
};

export default DataPiker;
